import * as Yup from 'yup';
import { EMAIL_VALIDATION_PATTERN, ONLY_DIGITS_REGEX_ALT } from '../../constants/patterns';
import { armCellPhoneNumberPrefixes } from '../userFormValidations';

export const payerContactInfoSchema = Yup.object().shape({
  firstName: Yup.string().required('validationErrors.isRequired'),
  lastName: Yup.string().required('validationErrors.isRequired'),
  email: Yup.string()
    .matches(EMAIL_VALIDATION_PATTERN, 'validationErrors.invalidEmail')
    .required('validationErrors.isRequired'),
  emailConfirm: Yup.string()
    .when(['isEmailDefault'], {
      is: (isEmailDefault) => isEmailDefault === true,
      then: Yup.string().notRequired(),
      otherwise: Yup.string()
        .oneOf([Yup.ref('email'), ''], 'validationErrors.emailsDoNotMatch')
        .required('validationErrors.isRequired'),
    }),
  mobilePhone: Yup.string()
    .required('validationErrors.isRequired')
    .when(['isPhoneDefault'], {
      is: (isPhoneDefault) => isPhoneDefault === true,
      then: Yup.string().required('validationErrors.isRequired'),
      otherwise: Yup.string()
        .test('cellPhone', 'validationErrors.wrongMobilePhoneNumber.onlyDigits', (value) => ONLY_DIGITS_REGEX_ALT.test(value))
        .test(
          'armenianCellLength',
          'validationErrors.wrongMobilePhoneNumber.length',
          (value = '') => value.length === 0 || value.length === 9,
        )
        .test(
          'armenianCellPrefix',
          'validationErrors.wrongMobilePhoneNumber.code',
          (value = '') => value.length === 0 || armCellPhoneNumberPrefixes.indexOf(value.slice(0, 3)) !== -1,
        ),
    }),
});

export const attachNewCardSchema = Yup.object().shape({
  attachCardAgreement: Yup.boolean().oneOf([true], 'validationErrors.isRequired'),
});
